module.exports = __webpack_public_path__ + "static/homepage_banner_2019-dce4910929e182688f471befdeff36be.svg";